module.exports = __webpack_public_path__ + "img/lbr.80576de4.svg";